<template>
  <v-content style="margin:0; padding: 0;">
    <h2><b>{{$t('json.signupsimtab')}}</b></h2>
    <v-form v-if="processType === 'Invoice Reading'" ref="signUpForm">
      <v-row>
        <v-col cols="12"><v-select v-model="processType" :disabled="disable" :items="processTypes" :label="$t('json.signupsimtab_ptypes')"></v-select></v-col>
        <v-col v-show="processType === 'Invoice Reading'" cols="12"><v-text-field v-model="email" :disabled="disable" :label="$t('json.signupsimtab_email')" required :rules="rules.emailRules"></v-text-field></v-col>
        <v-col v-show="processType === 'Invoice Reading'" cols="12">
          <v-text-field type="password" v-model="password" :disabled="disable" :label="$t('json.signupsimtab_pass')" required :rules="rules.passRules"></v-text-field>
          <span style="font-size: 10px !important;">At least: 8 characters, 1 uppercase letter, 1 special character</span>
        </v-col>
        <v-col v-show="processType === 'Invoice Reading'" cols="12"><v-text-field type="password" v-model="re_password" :disabled="disable" :label="$t('json.signupsimtab_repass')" required :rules="rules.repassRules"></v-text-field></v-col>
        <v-col v-show="processType === 'Invoice Reading'" cols="12"><v-select v-model="country" :items="languages" item-text="name" item-value="value" :disabled="disable" :label="$t('json.signupsimtab_country')" required :rules="rules.countryRules"></v-select></v-col>
        <v-col cols="12" v-show="error.code !== 200"><p style="color: red">{{ error.message }}</p></v-col>
        <v-col v-show="processType === 'Invoice Reading'" cols="12">
          <v-checkbox :disabled="disable" color="primary" :label="$t('json.signupsimtab_form_terms_agree')" :rules="rules.terms">
            <template v-slot:label>
              <div>
                {{ $t('json.signupsimtab_form_terms_agree') }}
                <span style="color: #1976D2 !important; cursor: pointer !important;" @click="dialogTerms = true">
                      {{ $t('json.signupsimtab_form_terms') }}
                </span>
              </div>
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="12"><v-btn :disabled="disable" color="primary" @click="signUp">{{ $t('json.signupsimtab_signup') }}</v-btn></v-col>
      </v-row>
    </v-form>
    <v-form v-if="processType === 'Document Exchange'" ref="exchangeUpForm">
      <v-row>
        <v-col cols="12"><v-select v-model="processType" :disabled="disable" :items="processTypes" :label="$t('json.signupsimtab_ptypes')"></v-select></v-col>
        <v-col v-show="processType === 'Document Exchange'" cols="12"><v-text-field v-model="promoCode" :disabled="disable" :label="$t('json.signupsimtab_pcode')"></v-text-field></v-col>
        <v-col v-show="processType === 'Document Exchange'" cols="12"><v-text-field v-model="projectName" :disabled="disable" :rules="rules.empty" :label="$t('json.signupsimtab_rpname')"></v-text-field></v-col>
        <v-col v-show="processType === 'Document Exchange'" cols="12"><v-textarea v-model="recipients" :disabled="disable" :rules="rules.empty" :label="$t('json.signupsimtab_rsl')"></v-textarea></v-col>
        <v-col cols="12" v-show="error.code !== 200"><p style="color: red">{{ error.message }}</p></v-col>
        <!-- <v-col v-show="processType === 'Document Exchange'" cols="12">
           <v-checkbox :disabled="disable" color="primary" :label="$t('json.signupsimtab_form_terms_agree')" :rules="rules.terms">
            <template v-slot:label>
              <div>
                {{ $t('json.signupsimtab_form_terms_agree') }}
                <span style="color: #1976D2 !important; cursor: pointer !important;" @click="dialogTerms = true">
                  {{ $t('json.signupsimtab_form_terms') }}
                </span>
              </div>
            </template>
          </v-checkbox>
        </v-col> -->
        <v-col cols="12"><v-btn :disabled="disable" color="primary" @click="signUp">{{ $t('json.signupsimtab_invite') }}</v-btn></v-col>
      </v-row>
    </v-form>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>{{ dialogMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">{{ $t('app.btclose') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogTerms" persistent max-width="65%">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text v-html="terms"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialogTerms = false">{{ $t('app.btclose') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-content>
</template>

<script>
import axios from 'axios'
import HtmlTerms from './../Terms'
export default {
  name: 'SignupSIM',
  props: {
    props: {
      type: Object,
      default: null
    },
    disable: {
      type: Boolean,
      default: false
    },
    SimSettings: {
      type: Object
    }
  },
  data () {
    return {
      terms: HtmlTerms,
      dialogTerms: false,
      dialog: false,
      dialogMessage: '',
      email: '',
      password: '',
      re_password: '',
      country: 'en',
      recipients: '',
      promoCode: '',
      projectName: '',
      processType: 'Invoice Reading',
      processTypes: ['Document Exchange', 'Invoice Reading'],
      languages: [{ name: 'English', value: 'en' }, { name: 'Slovenian', value: 'si' }, { name: 'Croatian', value: 'hr' }, { name: 'Serbian', value: 'sr' }, { name: 'Montenegrin', value: 'me' }, { name: 'Turkish', value: 'tr' }, { name: 'Hebrew', value: 'heb' }],
      error: {
        code: 200,
        message: ''
      },
      rules: {
        empty: [
          v => !!v || this.$i18n.t('json.signupsimtab_form_filedReq')
        ],
        emailRules: [
          v => !!v || this.$i18n.t('json.signupsimtab_form_filedReq'),
          v => /.+@.+\..+/.test(v) || this.$i18n.t('json.signupsimtab_form_emailv')
        ],
        passRules: [
          v => !!v || this.$i18n.t('json.signupsimtab_form_filedReq'),
          v => v.length >= 8 || this.$i18n.t('json.signupsimtab_form_pass1'),
          // eslint-disable-next-line no-useless-escape
          v => /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(v) || this.$i18n.t('json.signupsimtab_form_pass2'),
          v => /^(?=.*[A-Z])/.test(v) || this.$i18n.t('json.signupsimtab_form_pass2')
        ],
        repassRules: [
          v => this.password === this.re_password || this.$i18n.t('json.signupsimtab_form_pass3')
        ],
        countryRules: [
          v => !!v || this.$i18n.t('json.signupsimtab_form_filedReq')
        ],
        terms: [
          v => v === true || this.$i18n.t('json.signupsimtab_from_ruleterm')
        ]
      }
    }
  },
  methods: {
    async signUp () {
      console.log('signUp', this.processType)
      this.error.code = 200
      this.error.message = ''
      this.dialogMessage = ''
      const pType = this.processType
      if (this.SimSettings.PasswordCrypt === '') {
        this.error.code = 401
        this.error.message = ''
        return
      }
      if (this.processType === 'Invoice Reading') {
        try {
          if (!this.$refs.signUpForm.validate()) { return }
          const d = { email: this.email, password: this.password, country: this.country }
          await axios.post('http://192.168.95.121:8081/rs/portal/signUp', d)
          this.dialogMessage = this.$i18n.t('json.signupsimtab_form_info1')
          this.dialog = true
          this.$refs.signUpForm.reset()
        } catch (err) {
          if (err.response !== undefined) {
            this.error.code = err.response.status
            this.error = err.response.data
          } else {
            this.error.code = 500
            this.error.message = err.message
          }
        }
      } else if (this.processType === 'Document Exchange') {
        try {
          if (!this.$refs.exchangeUpForm.validate()) { return }
          const authorization = 'Basic ' + this.SimSettings.PasswordCrypt
          const d = { email: this.recipients, projectName: this.projectName, promoCode: this.promoCode }
          await axios.post('http://192.168.95.121:8081/rs/user/invite', d, { headers: { Authorization: authorization } })
          this.dialogMessage = this.$i18n.t('json.signupsimtab_form_info2')
          this.dialog = true
          this.$refs.exchangeUpForm.reset()
        } catch (err) {
          console.log(err, err.message, err.request)
          console.log(JSON.stringify(err))
          if (err.response !== undefined) {
            this.error.code = err.response.status
            this.error = err.response.data
          } else {
            this.error.code = 500
            this.error.message = err.message
          }
        }
      }
      this.processType = pType
    }
    /* async onChange (val) {
      this.$emit('changeSettings')
    } */
  }
}
</script>
